import handleViewport from 'react-in-viewport';

const Marker = (props: {
  forwardedRef: { current: HTMLDivElement | null };
  length: number;
  index: number;
  indexFetchSongs: number;
}) => {
  const { forwardedRef, length, index, indexFetchSongs } = props;
  const isDisplayedMain = length - index === indexFetchSongs;
  return isDisplayedMain ? <div ref={forwardedRef} /> : null;
};

// @ts-ignore
const ViewportMarker = handleViewport(Marker, {});

export default ViewportMarker;
